<template>
  <v-navigation-drawer v-model="drawer" fixed app>
    <v-list>
      <v-list-item class="secondary logo" :style="logoStyle">
        <router-link to="/" class="d-flex align-center">
          <img src="/images/logo.png" alt="eVote logo">
        </router-link>
      </v-list-item>

      <v-list-item v-if="loggedIn" :to="{ name: 'profile' }">
        <v-list-item-icon>
          <v-icon>person</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ user.first_name }} {{ user.last_name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="loggedIn"></v-divider>

      <template v-for="item in menu">
        <v-list-item color="primary" link :to="{ name: item.name }" :key="`menu-${item.name}`"
          v-if="(!item.auth && !loggedIn) || (item.auth && loggedIn) || typeof item.auth === 'undefined'">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title color="secondary title">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <template v-slot:append>
      <div class="pa-4" v-if="loggedIn">
        <v-btn block color="primary" @click="logout"><small>Изход</small></v-btn>
      </div>
      <div class="pa-4" v-else>
        <v-btn block color="primary" :to="{ name: 'login' }"><small>Вход</small></v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style lang="scss">
.v-navigation-drawer {
  padding-top: env(safe-area-inset-top, 20px);
  padding-left: env(safe-area-inset-left, 20px);
  padding-bottom: env(safe-area-inset-bottom, 20px);
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavigationDrawer',

  data() {
    return {
      menu: [
        { name: 'events', title: 'Заседания', icon: 'event' },
        { name: 'elections', title: 'Избори', icon: 'event_available', auth: true },
        { name: 'news', title: 'Новини', icon: 'library_books' },
        { name: 'campaigns', title: 'Кампании', icon: 'sms_failed' },
        { name: 'questionnaires', title: 'Анкети', icon: 'assessment', auth: true },
        { name: 'about', title: 'За нас', icon: 'info' },
      ]
    }
  },

  computed: {
    logoStyle() {
      return this.$vuetify.breakpoint.mdAndUp ? { height: '64px' } : { height: '56px' }
    },
    drawer: {
      get() {
        return this.$vuetify.breakpoint.lgAndUp ? true : this.$store.getters.drawer
      },
      set(isOpen) {
        this.$store.commit('toggleDrawer', isOpen)
      }
    },
    ...mapGetters(['loggedIn', 'user'])
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/вход')
      })
    },
  }
}
</script>

<style lang="scss">
.logo {
  padding: 0;

  &:hover {
    cursor: pointer;
  }

  img {
    width: 100%;
    height: 48px;
    object-fit: contain;
  }
}

.v-navigation-drawer {
  &:before {
    content: '';
    background-color: rgb(60, 60, 60);
    width: 100%;
    height: 62px;
    position: absolute;
    top: 0;
  }

  .v-list {
    padding-top: 0;
  }
}
</style>
